import { config } from '@uhg-abyss/web/tools/config';
import { event } from '@uhg-abyss/web/tools/event';
import { adobeAnalytics } from '@uhg-abyss/web/tools/event/listeners/adobeAnalytics';
import { dynatraceAnalytics } from '@uhg-uhcpp-sde-core/monstera-utility';
import { elasticApmAnalytics } from './elasticApm';
import { adobeTags } from './tags/adobe';
import { dynatraceTags } from './tags/dynatrace';
import { elasticApmTags } from './tags/elasticApm';

const maskAdobeClickTracking = () => {
  event.waitFor(
    () => {
      return window.s && window.s.ActivityMap;
    },
    () => {
      window.s.ActivityMap.link = () => {
        return null;
      };
    }
  );
};

export const ADOBE_ANALYTICS_ID = 'adobe-analytics-apimarketplace';

export const registerAnalytics = (data) => {
  maskAdobeClickTracking();

  const adobeData = adobeAnalytics({
    id: 'adobe-analytics-apimarketplace',
    enabled: config('ANALYTICS_TRACKING'),
    logging: config('ANALYTICS_LOGGING'),
    events: adobeTags,
    metadata: data,
  });

  const elasticApmData = elasticApmAnalytics({
    id: 'elastic-apm',
    enabled: config('ANALYTICS_TRACKING'),
    logging: config('ANALYTICS_LOGGING'),
    events: elasticApmTags,
    metadata: data,
  });

  const dynatraceData = dynatraceAnalytics({
    id: 'dynatrace-apimarketplace',
    enabled: config('DYNATRACE_ANALYTICS_TRACKING'),
    logging: config('DYNATRACE_ANALYTICS_LOGGING'),
    events: dynatraceTags,
    metadata: data,
  });

  event.listener(elasticApmData);

  event.listener(adobeData);

  event.listener(dynatraceData);
};
